import { SectionEmpty } from "@/components/ui/states";

/* What a cashier route answers from a region it is not licensed for: a 403 on
   `GET /deposit/{routeId}` or `GET /withdraw/{routeId}`. The whitelabel's
   Geoblock, word for word. */
export function GeoblockNotice() {
  return (
    <SectionEmpty
      icon="lock"
      title="Not available in your region"
      body="For compliance with regional laws, our services may be restricted in your location. If you're using a VPN, turn it off and retry."
    />
  );
}
